import { render, staticRenderFns } from "./RecipeIngredients.vue?vue&type=template&id=80c433f8&"
import script from "./RecipeIngredients.vue?vue&type=script&lang=js&"
export * from "./RecipeIngredients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports